import { InfoRounded } from "@material-ui/icons";
import { useStyles } from "@webapps/styles";

const InfoError = ({text}) => {
    const { classes } = useStyles(styles);
    return (
        <div className={classes["framerDiv4"]}>
            <InfoRounded className={classes["infoIconError"]}
            />
            <div className={classes["framerP3"]}>
                {text}
                {/* <strong className={classes["framerText4"]}> ({displayAndPluralize(unusedSmartfields.length, 'champ', 'champs')})</strong> */}
            </div>
        </div>
    );
};

const styles = {
    "framerDiv4": {
        borderBottomWidth: "1px",
        borderColor: "#f50057",
        borderLeftWidth: "1px",
        borderRightWidth: "1px",
        borderStyle: "dashed",
        borderTopWidth: "1px",
        alignItems: "center",
        backgroundColor: "#fbd3d5",
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px",
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
        display: "flex",
        flexDirection: "row",
        height: "min-content",
        justifyContent: "flex-start",
        paddingBottom: "10px",
        paddingLeft: "10px",
        paddingRight: "10px",
        paddingTop: "10px",
        width: "100%",
        gap: "5px",
        overflow: "hidden",
    },
    "infoIconError": {
        height: "16px",
        width: "16px",
        fill: "#f50057",
    },
    "framerP3": {
        fontFamily: "\"Roboto\", sans-serif",
        fontSize: "14px",
        // lineHeight: "16px",
        textAlignment: "left",
        color: "#f50057",
    },
    "framerText4": {
        fontFamily: "\"Roboto\", sans-serif",
        fontSize: "14px",
        // lineHeight: "16px",
        textAlignment: "left",
        color: "#f50057",
    },
}
export default InfoError;
